module.exports = __webpack_public_path__ + "img/loading.52da8f6a.svg";